import React from 'react'
import { AddText, AddSimpleChoice, AddCardChoice, AddImage, AddPdf, AddCarousel, AddMarkdown, AddAdaptiveCard } from '../../../../chat/pages/content/components'

type Props = {
	contentType: string
	onCreate: (contentId: string) => void
	isOpen: boolean
	close: () => void
	refetchContent: () => void
	[key: string]: any
}

export function AddContent(props: Props) {
	const { contentType, ...restProps } = props
	const contentTypes: Record<string, any> = {
		text: AddText,
		simpleChoice: AddSimpleChoice,
		cardChoice: AddCardChoice,
		image: AddImage,
		pdf: AddPdf,
		autoComplete: AddCardChoice,
		markdown: AddMarkdown,
		adaptiveCard: AddAdaptiveCard,
		cardCarousel: AddCarousel,
	}

	const Component = contentTypes[props.contentType]

	if(!Component) {
		return null
	}

	if(contentType === "autoComplete") {
		(restProps as any)["isAutocomplete"] = true
	}

	return <Component key={props.isOpen} {...restProps} />
}
